//extracted by mini-css-extract-plugin
export default {"horizontalChips":"CustomBadgeComponent_horizontalChips__b-DGf","added":"CustomBadgeComponent_added__qV0Jc","removed":"CustomBadgeComponent_removed__Jp6Bj"};;